import Axios from 'axios'

import {
  standardizeAddressForBigC,
  standardizeOrderFromResponse,
  MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing,
} from '@/services/Standardizers'

import { log, error } from '@/services/Log'
//---------------------------------------------------------------

export const preparePayloadToRecoverAvailableShippingOptions = ({ order, shipmentId }) => {
  const shipment = { ...order?.shipments.find(({ id }) => id === shipmentId) }
  shipment.shippingAddress.street1 += ' '
  const payload = {
    shippingAddress: standardizeAddressForBigC({ ...shipment?.shippingAddress }),
    lineItems: shipment?.lineItems.map(({ id: itemId, quantity }) => ({
      itemId,
      quantity,
    })),
  }
  const url = `/api/storefront/checkouts/${order?.cart?.id}/consignments/${shipment?.id}?include=consignments.availableShippingOptions`
  return { payload, url }
}

export const digestResponseFromAddressUpdate = async ({
  status, bigcResponse, shipmentId, order,
}, augment = true) => {
  const newOrder = standardizeOrderFromResponse({ order, bigcResponse })
  const shipment = newOrder?.shipments.find(({ id }) => id === shipmentId)
  if (augment) { // test purity escape hatch while we are refactoring standardization
    await MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing({ order: newOrder })
  }
  const success = status === 200 && shipment?.availableShippingOptions.length > 0
  return { success, newOrder, shipment }
}
// Tweaks the address to force BigCommerce to return a valid shipping quote
export const recoverAvailableShippingOptions = async ({
  order, shipmentId, attempts = 0, retries = 3,
}) => {
  // should only be called when bigC cache fails and available shipping options is empty
  log('recoverAvailableShippingOptions START', {
    order, shipmentId, attempts, retries,
  })
  const attempt = attempts + 1
  const { payload, url } = preparePayloadToRecoverAvailableShippingOptions({ order, shipmentId })
  try {
    const { data: bigcResponse, status } = await Axios.put(
      url,
      payload,
    )
    const { success, newOrder, shipment } = await digestResponseFromAddressUpdate({
      status, bigcResponse, shipmentId, order,
    })
    if (!success && attempt < retries) {
      return recoverAvailableShippingOptions({ order, shipmentId, attempts: attempt })
    } if (!success) {
      throw new Error(`Failed to update consignment with Address ${JSON.stringify({ url, payload })}`)
    }
    log('recoverAvailableShippingOptions END', { success, newOrder, shipment })
    return { success, newOrder, shipment }
  } catch (err) {
    error('recoverAvailableShippingOptions ERROR', { err })
  }
  return { success: false }
}
